// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121659/js/" + chunkId + "." + {"44":"04dfbc22","225":"37c52e37","481":"6af454bb","486":"c759c5f2","770":"0ca0ac67"}[chunkId] + ".0.4818686728819277.chunk.js";
};